// Feature flags returned by the pxe-backend /api/feature-flags endpoint,
// stored in the zustand global slice
export const FEATURE_FLAGS = {
  PUBLIC_RETROFIT_ROLLOUT: 'PUBLIC_RETROFIT_ROLLOUT',
  PUBLIC_RETROFIT_LOGIN_EMAIL: 'PUBLIC_RETROFIT_LOGIN_EMAIL',
  SUNRUN_DOT_COM_QUOTE_STATES: 'SUNRUN_DOT_COM_QUOTE_STATES',
  SHOW_DIGITAL_COMMERCE_PROD: 'SHOW_DIGITAL_COMMERCE_PROD',
} as const;

export const EXPERIMENT_BUCKET_COOKIES = {
  PUBLIC_RETROFIT: 'pxe_public_retrofit_bucket',
};
